import { PolicyBaseModel } from '@/features/master-table/policy/_models/policy';
import { t } from '@/i18n';
import { z } from 'zod';

export const baseTextSearchCriteria = z.enum([
  'name',
  'purpose',
  'overview',
  'task',
  'fund_name',
  'fund_owner',
]);

export const BaseTextSearchCriteriaLabelModifier = {
  name: t('project-name'),
  purpose: t('project-purpose'),
  overview: t('project-overview'),
  task: t('project-task'),
  fund_name: t('fund-business-name'),
  fund_owner: t('fund-owner'),
} as const satisfies Record<z.infer<typeof baseTextSearchCriteria>, string>;

const PolicyBaseDataModel = PolicyBaseModel.pick({
  id: true,
  name: true,
  level: true,
}).extend({
  code: PolicyBaseModel.shape.code.optional(),
});

type NestedPolicies = z.infer<typeof PolicyBaseDataModel> & {
  descendant: NestedPolicies[];
};

export const PoliciesBaseDataModel: z.ZodType<NestedPolicies[]> =
  PolicyBaseDataModel.extend({
    descendant: z.lazy(() => PoliciesBaseDataModel),
  }).array();
